// extracted by mini-css-extract-plugin
export default {"melodyVideo":"kM-z","isFullWidth":"lM-z","landingPageVideo":"mM-z","play":"nM-z","iframeVideo":"oM-z","playHidden":"pM-z","fullwidth":"qM-z"};